module.exports = __webpack_public_path__ + "/822d94f19fe57477865209e1242a3c63.woff2";